module.exports = __webpack_public_path__ + "img/core2.f77f2eda.png";